import type { SessionStartOptions } from '@/utils/sessionStartFlow'
import { parseSessionStartOptions } from '@/utils/sessionStartOptionsStorage'

export const PRACTITIONER_SETUP_DEFAULTS_KEY = 'fitutogether-practitioner-setup-defaults'

export const BUILTIN_PRACTITIONER_SETUP_DEFAULTS: SessionStartOptions = {
  includeWotCheck: true,
  includeWarmup: true,
  moodCheckMode: 'together',
}

export function readPractitionerSetupDefaults(): SessionStartOptions | null {
  try {
    const raw = localStorage.getItem(PRACTITIONER_SETUP_DEFAULTS_KEY)
    if (!raw) return null
    return parseSessionStartOptions(JSON.parse(raw))
  } catch {
    return null
  }
}

export function writePractitionerSetupDefaults(options: SessionStartOptions): void {
  try {
    localStorage.setItem(PRACTITIONER_SETUP_DEFAULTS_KEY, JSON.stringify(options))
  } catch {
    /* quota — fail silently */
  }
}

export function resolvePractitionerSetupDefaults(): SessionStartOptions {
  return readPractitionerSetupDefaults() ?? BUILTIN_PRACTITIONER_SETUP_DEFAULTS
}
